// RowsPerPageSelector.tsx
import React from 'react';
import { EllipsisText } from '@app/hooks/useDataTable/dataTableHelper';
import { useTranslation } from 'react-i18next';
import TnkDropdown from '../TnkDropdown';

interface RowsPerPageSelectorProps {
  rows: number;
  onRowsChange: (newRows: number) => void;
  options: number[];
}

const RowsPerPageSelector: React.FC<RowsPerPageSelectorProps> = ({ rows, onRowsChange, options }) => {
  const { t } = useTranslation();
  const dropdownOptions = options.map((opt) => ({
    label: t(`common.paginator.pagination.items${opt}`),
    value: opt,
  }));
  return (
    <div className="flex align-items-center gap-2 rows-per-page-selector">
      <EllipsisText className="ellipsis-text body-sm font-normal rows-per-page-selector__label">
        {t('common.paginator.displayCount')}
      </EllipsisText>
      <TnkDropdown
        value={rows}
        options={dropdownOptions}
        onChange={(e) => onRowsChange(e.value)}
        style={{ minWidth: '80px', height: '28px', display: 'flex', alignItems: 'center' }}
        className="p-dropdown"
        appendTo={document.body}
      />
    </div>
  );
};

export default RowsPerPageSelector;
